export default __webpack_public_path__ + "static/flowchart-82f03e52746443e41991017cc25faec1.webp";